import React, { useState, useContext } from 'react';

import ArrowRight from '../../assets/images/arrowRight.svg';

/** context */
import { UserContext } from '../../context/UserContext';
import { formatUSDCurrency } from '../../helpers/format';

/** service */
import { updateApplication, validateProperty } from '../../service/api';

export default function BnplApproved({ className, gotoNextStep }) {
  const { appData, updateAppData, setLoading } = useContext(UserContext);
  const multiApprovedRateFeature = appData?.applicationFeatures?.find(
    (feature) => feature.itemType === 'MultiApprovedRateProperty'
  );
  const downPayment = Number(
    multiApprovedRateFeature?.value?.rates[0]?.approvedRate?.downPaymentToMerchant
  );
  const [selectedTerm, setSelectedTerm] = useState(multiApprovedRateFeature?.value?.selectedIndex);
  const [error, setError] = useState('');

  const selectTerm = async (selectedIndex) => {
    gotoNextStep();

    setSelectedTerm(selectedIndex);

    setLoading(true);
    try {
      const updatedData = await updateApplication([
        {
          itemType: multiApprovedRateFeature.itemType,
          dataType: multiApprovedRateFeature.dataType,
          name: multiApprovedRateFeature.name,
          value: {
            selectedIndex,
            rates: multiApprovedRateFeature.value?.rates,
          },
        },
      ]);

      if (updatedData.data) {
        updateAppData(updatedData.data);
      }

      const validationData = await validateProperty(multiApprovedRateFeature.name);

      if (validationData.data && validationData.data.errors) {
        if (validationData.data.errors.length) {
          return false;
        }
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      const errors = error.response.data.errors;
      if (errors.length) {
        setError(errors[0].message);
      }
      setLoading(false);
      return;
    }

    gotoNextStep();
  };

  return (
    <>
      <div className={className}>
        <div className={`${className}__title`}>
          <h1>
            You have been approved for{' '}
            {formatUSDCurrency(
              multiApprovedRateFeature?.value?.rates[0]?.approvedRate?.maxApprovedAmount
            )}
          </h1>
          {downPayment != 0 && (
            <div className={`${className}__title-details`}>
              A {formatUSDCurrency(downPayment)} down payment will need to be paid to the merchant.
            </div>
          )}
          <div className={`${className}__title-details`}>
            <p>Please choose a financing plan.</p>
          </div>
        </div>
        <div className={`${className}__divider`} />
        <div className={`${className}__terms`}>
          {multiApprovedRateFeature?.value?.rates.map((item, index) => (
            <div
              className={`${className}__terms-item`}
              key={`${className}__terms-item-${index}`}
              onClick={() => selectTerm(index)}
            >
              <div className={`${className}__terms-item-row`}>
                <div className={`${className}__term-data`}>
                  <div className={`${className}__term-data__monthly-rate`}>
                    <span className={`${className}__term-data__monthly-rate__amount`}>
                      {formatUSDCurrency(item.monthlyPayment)}
                    </span>{' '}
                    / {item?.approvedRate?.approvedTermUnit}
                  </div>
                  {}
                  <div
                    className={
                      selectedTerm === index
                        ? `${className}__term-data__months-selected`
                        : `${className}__term-data__months`
                    }
                  >
                    {item?.approvedRate?.approvedTerm} months
                  </div>
                </div>
                <div className={`${className}__term-button`}>
                  <img src={ArrowRight} alt="arrow-right" />
                </div>
              </div>
              <div className={`${className}__terms-item-row props`}>
                <div className={`${className}__term-data`}>
                  <div className={`${className}__term-data-prop__label`}>APR</div>
                  <div className={`${className}__term-data-prop__value`}>
                    {item?.approvedRate?.approvedApr}%
                  </div>
                </div>
                <div className={`${className}__term-data`}>
                  <div className={`${className}__term-data-prop__label`}>Interest</div>
                  <div className={`${className}__term-data-prop__value`}>
                    {formatUSDCurrency(item?.totalInterest)}
                  </div>
                </div>
                <div className={`${className}__term-data`}>
                  <div className={`${className}__term-data-prop__label`}>Total</div>
                  <div className={`${className}__term-data-prop__value`}>
                    {formatUSDCurrency(item?.totalPayment)}
                  </div>
                </div>
              </div>
              <div className={`${className}__divider`} />
            </div>
          ))}
        </div>
        {error && <div className={`${className}__error`}>{error}</div>}
      </div>
    </>
  );
}
